import React, { useCallback } from "react";
import { Check } from "react-feather";
import classes from "./sortItem.module.css";

const SortItem = (props) => {
  const { active, onClick, sortItem } = props;

  const handleClick = useCallback(() => {
    onClick(sortItem);
  }, [sortItem, onClick]);

  const activeIcon = active ? <Check size={20} /> : null;

  return (
    <button className={classes.root} onClick={handleClick}>
      <span className={classes.content}>
        <span className={classes.text}>
          <span>{sortItem.text}</span>
        </span>
        {activeIcon}
      </span>
    </button>
  );
};

export default SortItem;
